"use strict";

exports.__esModule = true;
exports.dataHooks = exports.TOOLTIP_PLACEMENT = exports.STATUS = void 0;
var dataHooks = exports.dataHooks = {
  tooltip: 'status-indicator-tooltip'
};
var STATUS = exports.STATUS = {
  ERROR: 'error',
  WARNING: 'warning',
  LOADING: 'loading'
};
var TOOLTIP_PLACEMENT = exports.TOOLTIP_PLACEMENT = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};
//# sourceMappingURL=constants.js.map